import React from "react";
import googleIcon from "../assets/icons/google_icon.svg";

const GoogleAuthentication = () => {
  return (
    <button
      type="submit"
      className="group relative border border-light w-full flex justify-center align-middle mt-4 py-2 px-4 font-medium rounded-xl text-dark text-md md:text-lg bg-white hover:bg-light focus:outline-none focus:ring-0"
    >
      <img src={googleIcon} alt="googleIcon" className="pr-3 h-6 md:h-auto" />
      sign up with google
    </button>
  );
};

export default GoogleAuthentication;
